function pocketShowImage(gallery,id){
 if(!gallery)return;
 const image=gallery.querySelector('.po-gallery-item[data-image-id="'+id+'"]');
 if(!image)return;
 gallery.querySelectorAll('.po-gallery-item').forEach(item=>item.hidden=item!==image);
 const img=image.querySelector('img');if(img)img.loading='eager';
 gallery.querySelectorAll('[data-image-thumb]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.imageThumb===String(id))));
}
document.addEventListener('click',event=>{
 const button=event.target.closest('[data-image-thumb]');if(!button)return;
 const panel=button.closest('[data-product-panel]');if(!panel)return;
 const input=Array.from(panel.querySelectorAll('[data-variant-radio]')).find(input=>input.dataset.imageId===button.dataset.imageThumb);
 if(input&&!input.checked){input.checked=true;input.dispatchEvent(new Event('change',{bubbles:true}))}
 else pocketShowImage(panel.querySelector('[data-product-gallery]'),button.dataset.imageThumb);
});
document.addEventListener('change',event=>{
 const input=event.target.closest('[data-variant-radio]');
 if(!input)return;
 const panel=input.closest('[data-product-panel]');
 if(!panel)return;
 const price=panel.querySelector('[data-variant-price]');
 if(price){price.textContent=input.dataset.price; if(input.dataset.compare){const old=document.createElement('s');old.textContent=input.dataset.compare;price.append(' ',old)}}
 const available=input.dataset.available==='true';
 const submit=panel.querySelector('[data-product-submit]');
 if(submit){submit.disabled=!available;submit.textContent=available?submit.dataset.addLabel:submit.dataset.soldLabel}
 const payment=panel.querySelector('[data-product-payment]');if(payment)payment.hidden=!available;
 const gallery=panel.querySelector('[data-product-gallery]');
 pocketShowImage(gallery,input.dataset.imageId);
 const url=new URL(location.href);url.searchParams.set('variant',input.value);history.replaceState({},'',url);
 panel.dispatchEvent(new CustomEvent('variant:change',{bubbles:true,detail:{id:input.value,available}}));
});
